"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subappHybridInitializer = exports.asisSubappInitializer = exports.subappInitializerCC = exports.subAppDrPicasoInitializer = exports.subappInitializer = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const authenticator_initializers_1 = require("../../security/authenticator/authenticator.initializers");
const authoriser_initializer_1 = require("../../security/authoriser/authoriser.initializer");
const locale_initializers_1 = require("../../locale/locale.initializers");
const eventBus_initializer_1 = require("../../eventBus/eventBusManager/eventBus.initializer");
const featureFlag_initializer_1 = require("../../featureFlag/featureFlag.initializer");
const session_initializer_1 = require("../../security/session/session.initializer");
const tracker_initializer_1 = require("../../tracker/tracker.initializer");
const translations_initializer_1 = require("../../translations/translations.initializer");
const xhr_initalizer_1 = require("../../xhr/xhr.initalizer");
const usd_initializer_1 = require("../../security/usd/usd.initializer");
const challengeFactory_initializer_1 = require("../../security/authoriser/challenges/challengeFactory.initializer");
const usd_1 = require("../../security/usd");
const libraries_initializer_1 = require("../../libraries/libraries.initializer");
const mobileConnector_initializer_1 = require("../../mobileConnector/mobileConnector.initializer");
const commonsInitializers = (config, eventBusData) => {
    return {
        authoriser: new authoriser_initializer_1.AuthoriserInitializer(),
        locale: new locale_initializers_1.LocaleInitializer(config.language),
        eventBus: new eventBus_initializer_1.SetEventBusInitializer(eventBusData),
        libraries: new libraries_initializer_1.LibrariesInitializer(config.libraries()),
    };
};
const subappInitializer = async (config, featureFlagData, sessionData, eventBusData) => {
    const { authoriser, locale, eventBus } = commonsInitializers(config, eventBusData);
    const session = new session_initializer_1.SessionWithResetInitializer(config, sessionData, eventBus);
    const API = new xhr_initalizer_1.XhrInitializer(config, session, authoriser, locale);
    const authenticator = new authenticator_initializers_1.AuthenticatorInitializer(config, session, authoriser);
    const featureFlags = new featureFlag_initializer_1.AddFeatureFlagListInitializer(featureFlagData);
    const translations = new translations_initializer_1.TranslationInitializer(config.geTranslationsConfig(), API);
    const tracker = new tracker_initializer_1.TrackerInitializer(config.getTrackerConfig(), API, authenticator, eventBus);
    //TODO no siempre es necesario el USD Manager pero como lo necesita uno de los challenges, lo enviamos siempre.
    //Revisar esto para que solo se creen los challenges necesarios en cada caso.
    const usd = new usd_1.MockUSDManagerInitializer();
    const challengeFactory = new challengeFactory_initializer_1.ChallengeFactoryInitializer(API, session, usd, authoriser);
    const initializers = {
        locale,
        session,
        authoriser,
        API,
        authenticator,
        featureFlags,
        tracker,
        translations,
        eventBus,
        usd,
        challengeFactory,
    };
    const initializerManager = new web_ui_framework_1.InitializerManager(initializers);
    const initialized = await initializerManager.launchInitializers();
    return {
        session: initialized.session.getInitialized(),
        authoriser: initialized.authoriser.getInitialized(),
        API: initialized.API.getInitialized(),
        authenticator: initialized.authenticator.getInitialized(),
    };
};
exports.subappInitializer = subappInitializer;
const subAppDrPicasoInitializer = async (config, featureFlagData, sessionData, eventBusData) => {
    const { authoriser, locale, eventBus } = commonsInitializers(config, eventBusData);
    const session = new session_initializer_1.SessionDRPicasoInitializer(config, eventBus, sessionData);
    const authenticator = new authenticator_initializers_1.AuthenticatorDRPicasoInitializer(config, session);
    const usd = new usd_initializer_1.ModelbankUSDManagerInitializer(eventBus, session);
    //TODO Fix this. Caused because circular dependencies
    usd.setAuthenticator(authenticator);
    const API = new xhr_initalizer_1.XhrInitializer(config, session, authoriser, locale);
    const featureFlags = new featureFlag_initializer_1.AddFeatureFlagListInitializer(featureFlagData);
    const translations = new translations_initializer_1.TranslationInitializer(config.geTranslationsConfig(), API);
    const tracker = new tracker_initializer_1.TrackerUSDInitializer(config.getTrackerConfig(), usd, API, authenticator, eventBus);
    const challengeFactory = new challengeFactory_initializer_1.ChallengeFactoryInitializer(API, session, usd, authoriser);
    const initializers = {
        locale,
        session,
        authoriser,
        API,
        authenticator,
        featureFlags,
        tracker,
        translations,
        eventBus,
        challengeFactory,
        usd,
    };
    const initializerManager = new web_ui_framework_1.InitializerManager(initializers);
    const initialized = await initializerManager.launchInitializers();
    return {
        session: initialized.session.getInitialized(),
        authoriser: initialized.authoriser.getInitialized(),
        API: initialized.API.getInitialized(),
        authenticator: initialized.authenticator.getInitialized(),
    };
};
exports.subAppDrPicasoInitializer = subAppDrPicasoInitializer;
const subappInitializerCC = async (config, featureFlagData, sessionData, eventBusData, usdData) => {
    const { authoriser, locale, eventBus } = commonsInitializers(config, eventBusData);
    const usd = new usd_initializer_1.ModelbankUSDManagerInitializer(eventBus, usdData);
    const session = new session_initializer_1.USDSessionWithResetInitializer(config, sessionData, eventBus);
    const sessionDevCC = new session_initializer_1.SessionCCWithResetInitializer(config, sessionData, eventBus);
    const sessionDRPicaso = new session_initializer_1.SessionDRPicasoWithResetInitializer(config, sessionData, eventBus);
    const API = new xhr_initalizer_1.XhrInitializer(config, sessionDRPicaso, authoriser, locale);
    const authenticatorDRPicaso = new authenticator_initializers_1.AuthenticatorDRPicasoInitializer(config, sessionDRPicaso);
    const authenticator = new authenticator_initializers_1.AuthenticatorCCInitializer(config, session, sessionDRPicaso, sessionDevCC, authenticatorDRPicaso, usd);
    //TODO Fix this. Caused because circular dependencies
    usd.setAuthenticator(authenticator);
    const featureFlags = new featureFlag_initializer_1.AddFeatureFlagListInitializer(featureFlagData);
    const translations = new translations_initializer_1.TranslationInitializer(config.geTranslationsConfig(), API);
    const tracker = new tracker_initializer_1.TrackerUSDInitializer(config.getTrackerConfig(), usd, API, authenticator, eventBus);
    const challengeFactory = new challengeFactory_initializer_1.ChallengeFactoryInitializer(API, session, usd, authoriser);
    const initializers = {
        locale,
        session,
        sessionDevCC,
        sessionDRPicaso,
        authenticatorDRPicaso,
        authoriser,
        API,
        authenticator,
        featureFlags,
        tracker,
        translations,
        eventBus,
        usd,
        challengeFactory,
    };
    const initializerManager = new web_ui_framework_1.InitializerManager(initializers);
    const initialized = await initializerManager.launchInitializers();
    return {
        session: initialized.sessionDRPicaso.getInitialized(),
        authoriser: initialized.authoriser.getInitialized(),
        API: initialized.API.getInitialized(),
        authenticator: initialized.authenticator.getInitialized(),
        usd: initialized.usd.getInitialized(),
    };
};
exports.subappInitializerCC = subappInitializerCC;
const asisSubappInitializer = async (config, sessionData, eventBusData) => {
    const { authoriser, locale, eventBus } = commonsInitializers(config, eventBusData);
    const session = new session_initializer_1.AsisSessionResetInitializer(config, sessionData, eventBus);
    const API = new xhr_initalizer_1.XhrInitializer(config, session, authoriser, locale);
    const authenticator = new authenticator_initializers_1.AuthenticatorInitializer(config, session, authoriser);
    const featureFlags = new featureFlag_initializer_1.FeatureFlagInitializer(config.getFeatureFlagConfig(), API);
    const translations = new translations_initializer_1.TranslationInitializer(config.geTranslationsConfig(), API);
    const tracker = new tracker_initializer_1.TrackerInitializer(config.getTrackerConfig(), API, authenticator, eventBus);
    //TODO no siempre es necesario el USD Manager pero como lo necesita uno de los challenges, lo enviamos siempre.
    //Revisar esto para que solo se creen los challenges necesarios en cada caso.
    const usd = new usd_1.MockUSDManagerInitializer();
    const challengeFactory = new challengeFactory_initializer_1.ChallengeFactoryInitializer(API, session, usd, authoriser);
    const initializers = {
        locale,
        session,
        authoriser,
        API,
        authenticator,
        featureFlags,
        tracker,
        translations,
        eventBus,
        usd,
        challengeFactory,
    };
    const initializerManager = new web_ui_framework_1.InitializerManager(initializers);
    const initialized = await initializerManager.launchInitializers();
    return {
        session: initialized.session.getInitialized(),
        authoriser: initialized.authoriser.getInitialized(),
        API: initialized.API.getInitialized(),
        authenticator: initialized.authenticator.getInitialized(),
    };
};
exports.asisSubappInitializer = asisSubappInitializer;
const subappHybridInitializer = async (config, featureFlagData, sessionData, eventBusData) => {
    const { authoriser, locale, eventBus } = commonsInitializers(config, eventBusData);
    const mobileConnector = new mobileConnector_initializer_1.MobileConnectorInitializer();
    const session = new session_initializer_1.SessionWithResetHybridInitializer(sessionData, eventBus, mobileConnector);
    const API = new xhr_initalizer_1.XhrHybridInitializer(config, session, authoriser, locale, mobileConnector);
    const authenticator = new authenticator_initializers_1.AuthenticatorHybridInitializer(session, mobileConnector);
    const featureFlags = new featureFlag_initializer_1.AddFeatureFlagListInitializer(featureFlagData);
    const translations = new translations_initializer_1.TranslationInitializer(config.geTranslationsConfig(), API);
    const tracker = new tracker_initializer_1.TrackerInitializer(config.getTrackerConfig(), API, authenticator, eventBus);
    //TODO no siempre es necesario el USD Manager pero como lo necesita uno de los challenges, lo enviamos siempre.
    //Revisar esto para que solo se creen los challenges necesarios en cada caso.
    const usd = new usd_1.MockUSDManagerInitializer();
    const challengeFactory = new challengeFactory_initializer_1.ChallengeFactoryInitializer(API, session, usd, authoriser);
    const initializers = {
        locale,
        session,
        authoriser,
        API,
        authenticator,
        featureFlags,
        tracker,
        translations,
        eventBus,
        usd,
        challengeFactory,
        mobileCommunicator: mobileConnector,
    };
    const initializerManager = new web_ui_framework_1.InitializerManager(initializers);
    const initialized = await initializerManager.launchInitializers();
    return {
        session: initialized.session.getInitialized(),
        authoriser: initialized.authoriser.getInitialized(),
        API: initialized.API.getInitialized(),
        authenticator: initialized.authenticator.getInitialized(),
    };
};
exports.subappHybridInitializer = subappHybridInitializer;
//# sourceMappingURL=subapp.initializers.js.map